import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { adocbe, adocbf } from '@cyberdefense-im2/cyberdefense-psychopomp-web';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CharonSessionService } from './charon.http.session.service';


export const IS_CHARON_REQUEST = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class CharonHttpInterceptor implements HttpInterceptor {

  constructor(private charonSession: CharonSessionService) { }

  /**
  * Identifica e trata uma determinada requisição HTTP
  *
  * Identifies and handles a given HTTP request
  *
  * @param request requisição HTTP a ser tratada
  * @param next próximo interceptor
  */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.context.get(IS_CHARON_REQUEST)) {
      return from(this.handleCharonRequest(request, next));
    }

    /**
     * Trata query parametros da requisição e remove-os da url
     */
    let headers = request.headers;
    const charonParams = this.mapCharonParams(request);
    if (charonParams) {
      headers = headers.append('X-Charon-Params', (btoa(JSON.stringify(charonParams)) as string));
    }

    request = request.clone({ headers, params: new HttpParams() });

    return next.handle(request);
  }

  /**
  * Trata a requisição HTTP interceptada
  *
  * Handles intercepted HTTP request
  *
  * @param request requisição HTTP a ser tratada
  * @param next próximo interceptor
  */
  private async handleCharonRequest(request: HttpRequest<unknown>, next: HttpHandler) {
    let headers = request.headers;
    const charonParams = this.mapCharonParams(request);
    if (charonParams) {
      headers = headers.append('X-Charon-Params', (await adocbe(JSON.stringify(charonParams)) as string));
    }

    const body = await this.encryptBody(request);

    request = request.clone({
      headers,
      params: new HttpParams(),
      body
    });

    return this.decryptBody(request, next);
  }




  /**
  * Descriptografa o body da requisição
  *
  * Decrypt the request body
  *
  * @param request requisição HTTP a ser tratada
  * @param next próximo interceptor
  */
  private async decryptBody(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request)
      .pipe(
        map(async event => {

          if (!(event instanceof HttpResponse) || !event.ok) {
            return event;
          }

          let body: string | undefined;
          const isEncodingType = event.headers.get('X-Content-Encoding') === 'application/vnd-encode-4';
          const isContentType = event.headers.get('Content-Type')?.indexOf('application/json') != -1 || event.headers.get('Content-Type')?.indexOf('text/plain') != -1;

          if (isEncodingType && isContentType) {
            body = typeof event.body === 'string' && event.body ? JSON.parse(await adocbf(event.body)) : event.body;
          } else {
            body = event.body;
          }

          const eventHandle = event.clone({
            body
          });

          return eventHandle;

        })).toPromise();
  }

  /**
    * Mapeia os parâmetros passados na requisição
    *
    * Maps the parameters request
    *
    * @param request requisição HTTP a ser tratada
    */
  private mapCharonParams(request: HttpRequest<unknown>) {
    let result: any = null;
    const isRequestParam = request.params && request.params.keys().length > 0;

    if (isRequestParam) {
      result = {};
      request.params.keys().forEach(key => {
        result[key] = request.params.get(key);
        request.params.delete(key);
      });
    }

    return result;
  }

  /**
    * Criptografa o body da requisição
    *
    * Encrypt request body
    *
    * @param request requisição HTTP a ser tratada
    */
  private async encryptBody(request: HttpRequest<unknown>) {
    let body;
    const methods = ['POST', 'PUT', 'PATCH'];

    const isSomeMethod = methods!.some((element) => request.method.toUpperCase() === element);

    if (isSomeMethod) {
      if (request.body) {
        const serialize = (request as HttpRequest<any>).serializeBody();
        if (typeof serialize === 'string') {
          body = `${(await adocbe(serialize))}`;
        }
      }
    }

    return body;
  }

}
